export const canRotateObstacle = (obstacle) => Boolean(obstacle)
  && !["roof", "tree", "cylinder"].includes(obstacle.kind);

// Polygon coordinates already describe the rendered footprint. Apply only the
// change in bearing, so saving and reopening never rotates them a second time.
export function obstacleRotationPatch(obstacle, degrees) {
  if (!canRotateObstacle(obstacle) || degrees === "" || !Number.isFinite(Number(degrees))) return {};
  const rotationDeg = ((Number(degrees) % 360) + 360) % 360;
  if (obstacle.kind !== "polygon") return { rotationDeg };
  const angle = (rotationDeg - (Number(obstacle.rotationDeg) || 0)) * Math.PI / 180;
  const c = Math.cos(angle), s = Math.sin(angle);
  const footprint = (obstacle.footprint || []).map(({ x, y }) => ({ x: c * x + s * y, y: -s * x + c * y }));
  if (footprint.length < 3) return {};
  return { rotationDeg, footprint,
    widthM: Math.max(...footprint.map(p => p.x)) - Math.min(...footprint.map(p => p.x)),
    depthM: Math.max(...footprint.map(p => p.y)) - Math.min(...footprint.map(p => p.y)) };
}
